import React from 'react';
import { setSelected } from '../../actions';
import { useDispatch, useSelector, RootStateOrAny } from 'react-redux';
type HandProps = {
    name: string;
    index: number;
};

export default function HandItem(props: HandProps) {
    const dispatch = useDispatch();
    const selected = useSelector((state: RootStateOrAny) => state.selected);
    function setThisSelected() {
        dispatch(setSelected(props.index));
    }

    return (
        <td>
            <img
                src={require(`../../assets/characters/${props.name}.jpg`)}
                alt='character'
                onClick={setThisSelected}
                className={selected === props.index ? 'selected' : ''}
            />
        </td>
    );
}
